export default {
    Designer: {
        Toolbox: {
            OpenScenario: "Select scenario",
            OpenButton: "Open",
            SaveButton: "Save",
            PleaseSelect: "Select an element on the graph",
            LinkFields: {
                Choice: "Button label",
                ChoiceValue: "Chat text",
                Speak: "Speak",
                AlternateIntents: "Alternate Intents",
                AlternateEntities: "Alternate Entities",
                AlternateKeywords: "Alternate Keywords",
                Url: "Url",
                ImageUrl: "Image Url",
                Order: "Order",
                CTAType: "Action Type"
            },
            DiscardChanges: "Discard unsaved changes?",
            WarnNoStartNodes: "At least one Start node is required!",
            WarnStartNodesChanged: "Start nodes have changed since the original version.",
            EditJson: "Edit Scenario Definition"
        }
    },
    UserRoles:
    {
        Title: "User Roles Management",
        AddUser: "Add User",
        EditEmail: "Email",
        EditRole: "Role",
        Table:
        {
            UserEmailAddress: "Email",
            UserRoleType: "User Role",
            AssignedBy: "Assigned By",
            AssignedAt: "Assigned At"
        },
        Form: {
            EditTitle: "Edit User",
            NewTitle: "New User",
            NewButton: "New User"
        },
    },
    Scenarios: {
        Title: "Scenarios",

        Table: {
            Name: "Scenario name",
            Languages: "Languages",
            Category: "Cluster",
            Intents: "Intents",
            Entities: "Entities",
            Keywords: "Keywords",
            Channels: "Channels",
            UserTypes: "User Types",
            ScenarioDescription: "Scenario description",
            CheckedOutBy: "Checked out by",
            Market: "Market",
            Type: "Type",
            FallbackScenarioName: "Scenario disabled keyword",
            DisableScenario: "Disable Scenario",
            CustomScenario: "Is Custom Scenario"
        },
        History: {
            Title: "Scenario History",
            Timestamp: "Date/time",
            View: "View",
            Author: "Author",
            Languages: "Languages"
        },
        Form: {
            EditTitle: "Edit Scenario",
            NewTitle: "New Scenario",
            NewButton: "New scenario",
            CheckButton: "Check start conditions",
            ExportButton: "Export scenarios",
            ImportButton: "Import scenarios"
        },
        ExportDialog: {
            Title: "Export scenarios",
            ExportButton: "Export"
        },
        ImportDialog: {
            Title: "Import scenarios",
            ImportButton: "Import"
        },
        Check: {
            Title: "Scenario start consistency check",
            Table: {
                FirstScenario: "First Scenario",
                SecondScenario: "Second Scenario",
                Intents: "Intents",
                Entities: "Entities",
                Keywords: "Keywords",
                Channels: "Channels",
                ScenarioDescription: "Scenario description",
                CheckedOutBy: "Checked out by",
            }
        },
        Search:
        {
            Title: "Search",
            Scenario: "Scenario",
            OpenScenario: "Open",
            Occurrences: "Number of occurrences"

        },
    },
    Contents: {
        Title: "Contents",
        Form: {
            ScenarioName: "Scenario Name",
            ChangedBy: "Changed By",
            CheckedOutBy: "Checked Out By",
            OpenScenarioButton: "Open Scenario",
            SaveScenarioButton: "Save Scenario",
            CheckInButton: "Checkin Scenario",
            CheckOutButton: "Checkout Scenario",
            ResetChangesButton: "Reset latest changes",
            EditTitle: "Edit Content"
        },
        Table: {
            Type: "Action Type",
            Description: "Message Description",
            Message: "Message",
            Speak: "Speak",
            NoData: "No items found"
        }
    },
    Messages: {
        Title: "Messages",
        Table: {
            Keyword: "Keyword",
            Message: "Message",
            Language: "Language",
        },
        Form: {
            EditTitle: "Edit message",
            NewTitle: "New message",
            NewButton: "New message",
        },
    },
    Settings: {
        Title: "Settings",
        Table: {
            Name: "Name",
            Value: "Value",
        },
        Form: {
            EditTitle: "Edit setting"
        },
    },
    SSML: {
        Title: "SSML Library",
        Table: {
            Word: "Word",
            CaseSensitive: "Case Sensitive",
            SpaceSensitive: "Space Sensitive",
            Replacement: "Replacement SSML",
        },
        Form: {
            EditTitle: "Edit",
            NewTitle: "New",
            NewButton: "New",
        },
    },
    Release: {
        Title: "Release Management",
        Qna: {
            Title: "QnA",
            NoQnaAvailable: "There are no valid QnA environments configured in your app",
            // tslint:disable-next-line:max-line-length
            MainText: "Please select the environment where you want to release the QnA Knowledge Base, then select which KB you want to import. Please note that there might be some restricted environments (as for example production environment) where manual upload is not allowed.",
            // tslint:disable-next-line:max-line-length
            FileFormat: "NOTE: The file must be a valid CSV file where fields are separated by a tab. The file should have two mandatory headers: 'Question' (first column) and 'Answer' (second column). The file should be encoded as Unicode (UTF-16 LE). To save the file in the correct format with Excel, select 'Unicode Text (*.txt)' as file format when saving the file.",
            TargetLabel: "To which environment do you want to release the new Knowledge Base?",
            SourceLabel: "Select the Knowledge Base to be imported",
            ImportFrom: "Import KB from",
            SelectEnvironment: "Select the environment"
        },
        Luis: {
            Title: "Luis",
            NoLuisAvailable: "There are no valid Luis environments configured in your app",
            // tslint:disable-next-line:max-line-length
            MainText: "Please select the environment where you want to release the Luis.",
            TargetLabel: "To which environment do you want to release the new Model?",
            SourceLabel: "Select the Luis Model to be imported",
            ImportFrom: "Import Model from",
            SelectEnvironment: "Select the environment"
        },
        Dialogs: {
            Title: "Dialogs",
            NoDialogsAvailable: "There are no valid Dialogs environments configured in your app",
            // tslint:disable-next-line:max-line-length
            MainText: "Please select the environment where you want to release the Dialogs.",
            TargetLabel: "To which environment do you want to release the new Dialogs?",
            SourceLabel: "Select the Dialogs to be imported",
            ImportFrom: "Import Dialogs from",
            SelectEnvironment: "Select the environment"
        },
        UploadFileDialog: {
            Title: "Upload File",
            UploadButton: "Upload"
        }
    },
    AuthenticationVariables: {
        Title: "Authentication Variables",
        Table: {
            Key: "Unique Key",
            Cluster: "Cluster",
            Name: "Name",
            Channel: "Channel",
            SecurityLevel: "Security Level",
            SecurityLevelCopy: "Original Level",
            Description: "Description",
            ListOfValues: "ListOfValues"
        },
        Form: {
            EditTitle: "Edit variable",
            NewTitle: "New variable",
            NewButton: "New variable",
            SquashButton: "Force all to 40",
            ResetButton: "Reset all",
        },
    },
    IdentificationModels: {
        Title: "Identification Model",
        Table: {
            Key: "Unique Key",
            Name: "Name",
            Channel: "Channel",
            Strength: "Strength",
            IsAvailableInDialog: "IsAvailableInDialog"
        },
        Form: {
            EditTitle: "Edit model",
            NewTitle: "New model",
            NewButton: "New model",
        },
    },
    Global: {
        ApplicationTitle: "Bot Training Center",
        Navigation: {
            Designer: "Designer",
            Scenarios: "Scenarios",
            Contents: "Contents",
            Messages: "Messages",
            Settings: "Settings",
            AuthenticationVariables: "Auth Variables",
            IdentificationModels: "Identification Model",
            SSMLLibrary: "SSML Library",
            RoleManagement: "Role Management",
            ReleaseManagement: "Release Management",
            WebChat: "WebChat"
        },
        AllOption: "All",
        Close: "Close",
        Edit: {
            Confirm: "OK",
            Cancel: "Cancel"
        },
        Delete: {
            Confirm: "Are you sure to delete this item?"
        },
        LastEdit: "Last edit",
        LastEditBy: "Last edit by",
        Loading: "Loading"
    }
};


// WEBPACK FOOTER //
// ./src/i18n/en.ts